<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 7/9/2020
  -->

<template>
	<div class="radio-element-root">
		<FormMultipleView
			ref="formMultipleView"
			:formElement="formElement"
			:viewMode="viewMode"
			v-bind="$attrs">
			<template #body>
				<div class="qw-row">
					<div :class="{'col px-0': !isEditMode}">

						<table class="w-100">
							<tr v-if="formElement.showHeader">
								<td v-for="(column, index) of formElement.columnTitles" :key="index">
									<div class="qw-row mt-2"
										 :class="{'bold': !isEditMode || !isSelected}">
										<qw-input
											v-if="isEditable && isEditMode && isSelected"
											:class="{'white-smoke': isEditMode && isEditable && isSelected}"
											placeholder="Title"
											class="qw-col mr-2"
											v-model="formElement.columnTitles[index]">

											<template #append v-if="isSelected">
												<qw-button-delete v-if="formElement.columnTitles.length > 1"
																  @click="onDeleteColumn(index)"/>
											</template>
										</qw-input>

										<div v-else style="line-height: initial" class="pr-4 font-size-2">
											{{ formElement.columnTitles[index] }}
										</div>
									</div>
								</td>
							</tr>
							<tr v-for="(answerItem, rowIndex) of formElement.answerOptions"
								:key="'row_' + rowIndex">
								<td v-for="(answer, colIndex) of answerItem.answers"
									:key="'col_' + colIndex"
									:class="isAnswerMode ? 'pr-2' : 'pr-4'">

									<div class="qw-row1 mt-2">
										<qw-input
											:readonly="!isAnswerMode"
											:placeholder="placeholderText"
											:class="{'white-smoke': isAnswerMode}"
											class="w-100"
											v-model="answerItem.answers[colIndex]"
											:borderDotted="isEditMode">
											<template #append v-if="!formElement.showHeader && isSelected && rowIndex === 0">
												<qw-button-delete v-if="formElement.columnTitles.length > 1"
																  @click="onDeleteColumn(colIndex)"/>
											</template>

										</qw-input>
									</div>
								</td>
								<td style="width: 0">
<!--									:class="{'hide-opacity': !isAnswerMode || formElement.answerOptions.length <= 1}"-->

									<qw-button-delete
										v-if="isAnswerMode && formElement.answerOptions.length > 1"
										@click="onDeleteRow(rowIndex)"/>
								</td>

							</tr>
						</table>
					</div>

					<!--					<ToolTipView>-->
					<!--						This is a preview of what your client will see.-->
					<!--						&lt;!&ndash;						<br/><br/>&ndash;&gt;-->
					<!--						&lt;!&ndash;						Your client will be able to add multiple contacts.&ndash;&gt;-->
					<!--					</ToolTipView>-->

					<qw-link-button v-if="isSelected" @click="onAddColumnClicked">+Add&nbsp;Column</qw-link-button>

				</div>
				<qw-link-button v-if="isAnswerMode && formElement.allowAddingOptions" @click="addAnswer">
					+ Add one more answer
				</qw-link-button>

				<small v-if="isEditMode && formElement.allowAddingOptions && !isSelected" class="text-muted">
					<span class="fontello icon-ok"/> Client can add rows</small>

				<div class="mt-4" v-if="isSelected && isEditMode">
					<div>
						<qw-checkbox
							v-model="formElement.allowAddingOptions"
							@change="notifyElementChanged">
							Client can add rows
						</qw-checkbox>
					</div>
					<div>
						<qw-checkbox
							v-model="formElement.showHeader"
							@change="notifyElementChanged">
							Show header
						</qw-checkbox>
					</div>
				</div>

			</template>
		</FormMultipleView>
	</div>


</template>

<script>

import FormMultipleView from "@/core/modules/coach/Resources/Forms/FormElements/FormElementMultipleView.vue";
import BaseFormElementView from "@/core/modules/coach/Resources/Forms/FormElements/BaseFormElementView.vue";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import QwButtonDelete from "@/core/components/Controls/Buttons/QwButtonDelete.vue";
import ContactInfo from "@shared/Profile/ContactInfo";
import FormElementTextGrid from "@/core/modules/coach/Resources/Forms/model/FormElements/General/FormElementTextGrid";
import {deleteConfirmDialog} from "@/core/components/Dialogs/dialog";
import AnswersItem from "@/core/modules/coach/Resources/Forms/model/FormElements/General/AnswersItem";

export default {
	name: "FormElementTextGridView",
	components: {QwButtonDelete, ToolTipView, FormMultipleView},
	extends: BaseFormElementView,
	props: {
		formElement: {FormElementTextGrid, required: true}
	},


	methods: {

		onAddColumnClicked() {
			this.formElement.addColumn()
		},

		async onDeleteRow(index) {
			let res = await deleteConfirmDialog({itemName: "row"})
			if (res) {
				this.formElement.removeRow(index)
			}
		},

		async onDeleteColumn(index) {
			let res = await deleteConfirmDialog({itemName: "column"})
			if (res) {
				this.formElement.removeColumn(index)
			}
		},

		addAnswer() {
			this.formElement.addRow()
			this.notifyElementChanged()
		},

		deleteOption(index) {
			return this.$refs.formMultipleView.deleteOption(index)
		},

	},

	computed: {
		otherIndex() {
			return this.formElement.answerOptions.length
		},

		placeholderText() {
			if(this.isViewMode){
				return "No answer provided"
			}
			if(this.isAnswerMode){
				return "type here..."
			}
			return "Client's answer"
		}
	}


}
</script>

<style lang="scss">

.radio-element-root {
	.disableClick {
		cursor: default;
		outline: none;

		.el-radio__inner {
			border: 1px solid #DCDFE6;
			box-shadow: none !important;
			cursor: default;
		}

		.editMode {
			.el-radio__label {
				padding-left: 0;
			}
		}

		.el-radio, .el-radio__input, .el-radio__label, .el-radio__inner {
			cursor: default;
		}
	}
}

</style>
